import { render } from "./HolidayPage.vue?vue&type=template&id=2e7e8470&scoped=true"
import script from "./HolidayPage.vue?vue&type=script&lang=js"
export * from "./HolidayPage.vue?vue&type=script&lang=js"

import "./HolidayPage.vue?vue&type=style&index=0&id=2e7e8470&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7e8470"]])

export default __exports__